import React, { FC } from 'react'
import { Story, TStory } from '../index'

type TSharingStoryProps = {
  story: TStory
  children?: React.ReactNode
}

export const SharingStory: FC<TSharingStoryProps> = (props) => {
  const { story } = props

  return (
    <Story.Container story={story}>
      <Story.Header />

      <Story.Body>
        <Story.Article />
        <Story.Gallery />
        <Story.Comments />
        <Story.Divider/>
        {props.children}
      </Story.Body>

      <Story.Section>
        <Story.Meta />
        <Story.Tags />
      </Story.Section>

    </Story.Container>
  )
}
